module.exports = __webpack_public_path__ + "static/media/turda.b2122a20.png";